import appStore from 'store';
import api from './api';
import { STATUS, PAGINATION, RECORD_STATUS } from './constants';

const store = {
  namespaced: true,
  state: {
    taskList: [],
    recordList: [],
    totalCount: 0,
    recordTotalCount: 0,
    pagination: PAGINATION,
    recordPagination: PAGINATION,
    recordDialogVisible: false,
    checkTask: {},
    profit: 0
  },
  mutations: {
    setTaskList(state, payload) {
      state.taskList = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setTaskTotal(state, payload) {
      state.totalCount = payload;
    },
    setRecordList(state, payload) {
      state.recordList = payload;
    },
    setRecordPagination(state, payload) {
      state.recordPagination = payload;
    },
    setRecordTotal(state, payload) {
      state.recordTotalCount = payload;
    },
    setProfit(state, payload) {
      state.profit = payload;
    },
    setRecordDialogVisible(state, payload) {
      state.recordDialogVisible = payload;
    },
    setCheckTask(state, payload) {
      state.checkTask = payload;
    }
  },
  getters: {
    taskList(state) {
      return state.taskList.map(item => {
        return {
          ...item,
          __status: STATUS[item.status]
        };
      });
    },
    recordList(state) {
      return state.recordList.map(item => {
        return {
          ...item,
          __status: RECORD_STATUS[item.status]
        };
      });
    }
  },
  actions: {
    list({ commit }, query) {
      commit('setPagination', { page: query.page, size: query.size });

      api.listTasks(query).then(({ data }) => {
        commit('setTaskList', data.list);
        commit('setTaskTotal', data.totalCount);
      });
    },
    create(context, data) {
      return api.createTask(data);
    },
    update(context, data) {
      return api.updateTask(data);
    },
    remove({ commit }, id) {
      return api.removeTask(id);
    },
    execute({ commit }, id) {
      return api.executeTask(id);
    },
    updateProfit({ commit }, data) {
      return api.updateProfit(data);
    },
    getProfit({ commit }) {
      return api.getProfit().then(res => {
        commit('setProfit', res.data);
      });
    },
    listRecords({ commit }, query) {
      commit('setRecordPagination', { page: query.page, size: query.size });

      return api.listRecords(query).then(({ data }) => {
        commit('setRecordList', data.list);
        commit('setRecordTotal', data.totalCount);
      });
    },
    billTask(context, taskId) {
      return api.billTask({ taskId });
    },
    executeRecord(context, id) {
      return api.executeRecord(id);
    },
    executeAllRecords(context, taskId) {
      return api.executeAllRecords(taskId);
    }
  }
};

appStore.registerModule('dividendTask', store);
